
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import BuilderElement from "./BuilderElement.vue";
import NodeChrome from "./OverlaidUI/NodeChrome.vue";
import CanvasChrome from "./OverlaidUI/CanvasChrome.vue";
import { uiStore, documentStore, globalStore } from "@/store/store";
import EmptyContainer from "@/components/Canvas/Empty/EmptyContainer.vue";
import {
  handleGlobalSelectorsChanged,
  handleGlobalSettingsChanged,
  handlePresetsChanged
} from "@/lib/canvas/reacting-to-global-store-changes";
import { getBuilderCanvasDocument } from "@/lib/canvas/helpers";

@Component({
  components: {
    EmptyContainer,
    BuilderElement,
    NodeChrome,
    CanvasChrome
  }
})
export default class Canvas extends Vue {
  render() {
    const children = () => {
      if (this.rootElement.children.length === 0) {
        return <EmptyContainer />;
      }

      return this.rootElement.children.map(element => (
        <BuilderElement
          // @ts-ignore
          key={element.id}
          // @ts-ignore
          parentId={this.rootElement.id}
          element={element}
        />
      ));
    };

    return (
      <div
        key={this.canvasKey}
        class={this.classList}
        id="breakdance_canvas"
        style={this.style}
      >
        {children()}
        {!this.isPreviewMode && <NodeChrome />}
        {!this.isPreviewMode && <CanvasChrome />}
      </div>
    );
  }

  mounted() {
    uiStore.setCanvasState("normal");
  }

  get canvasKey() {
    return uiStore.canvasKey;
  }

  get isPreviewMode() {
    return uiStore.isPreviewMode;
  }

  get classList() {
    return {
      breakdance: true,
      canvas: true,
      dragging:
        uiStore.isCanvasElementBeingDragged || uiStore.isAddElementBeingDragged
    };
  }

  get rootElement() {
    return documentStore.document.tree.root;
  }

  get globalSettings() {
    return globalStore.globalSettings;
  }

  get selectors() {
    return globalStore.cssSelectors;
  }

  get presets() {
    return globalStore.presets;
  }

  get style() {
    const width = uiStore.canvasPreviewWidth.previewSize.width;
    const height = uiStore.canvasPreviewWidth.previewSize.height;
    return {
      width: width ? `${width}px` : undefined,
      height: height ? `${height}px` : undefined,
      margin: width || height ? `0 auto` : undefined
    };
  }

  @Watch("globalSettings", { deep: true, immediate: true })
  onGlobalSettingsChanged() {
    handleGlobalSettingsChanged(getBuilderCanvasDocument());
  }

  @Watch("selectors", { deep: true, immediate: true })
  onSelectorsChanged() {
    handleGlobalSelectorsChanged(getBuilderCanvasDocument());
  }

  @Watch("presets", { deep: true, immediate: true })
  onPresetsChanged() {
    handlePresetsChanged(getBuilderCanvasDocument());
  }
}
